import type { AlertColor } from 'src/shared/types/alert';

export enum Status {
    WARNING = 'warning',
    SUCCESS = 'success',
    ERROR = 'error',
    DISABLED = 'disabled',
    INVASIVE = 'invasive',
    UNKNOWN = 'unknown',
}

export const statusToAlertColor = (status: Status): AlertColor => {
    if (status === Status.ERROR) {
        return 'error';
    }

    if (status === Status.WARNING) {
        return 'warning';
    }

    if (status === Status.SUCCESS) {
        return 'success';
    }

    return 'info';
};
